import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { apiService } from '../../../services/apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronLeft, faChevronRight, faChevronUp, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';

const FILE_EXTENSIONS = /\.(jpe?g|png|gif|bmp|svg|webp|tiff?|ico|heic|pdf|docx?|xlsx?|pptx?|txt|csv|rtf|odt|ods|odp|mp3|wav|ogg|aac|flac|m4a|wma|mp4|mov|avi|mkv|webm|flv|wmv|m4v|zip|rar|7z|tar|gz|bz2)$/i;

const isFileUrl = (value) => typeof value === 'string' && value.startsWith('http') && FILE_EXTENSIONS.test(value);

const renderChangeValue = (value) => {
    if (!isFileUrl(value)) {
        return value;
    }
    return <a href={value} target="_blank" rel="noopener noreferrer">View</a>;
};

function ActivityTimeline() {
    const { id } = useParams();
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [expandedId, setExpandedId] = useState(null);

    const fetchEvents = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const response = await apiService.postRequest(`/admin/jobseeker-activity-timeline/${id}`, params);

            if (response && response.success === true) {
                setEvents(response.data || []);
                setPaginateData(response.meta);
            } else {
                if (response.authenticate === false) {
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error('Error fetching tab data:', error);
        } finally {
            setLoading(false);
        }
    }, [id]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        setExpandedId(null);
        fetchEvents({ page: newPage });
    };

    const toggleChanges = (eventId) => {
        setExpandedId((previous) => (previous === eventId ? null : eventId));
    };

    useEffect(() => {
        fetchEvents();
    }, [fetchEvents]);

    return (
        <Grid size={{ xs: 12 }} container className="border_recentdashboard" alignContent="flex-start">
            {loading ?
                <div className='d-flex justify-content-center w-100 mt-5 pt-5'>
                    <img style={{ width: "100px" }} src={require('../../../assets/pinkloader.gif')} alt='Loading...' />
                </div> : <>
                {events && events.length > 0 ? (<>
                    {events.map((event) => (
                        <Grid size={{ xs: 12 }} container key={event.id} justifyContent="space-between" className="pt-3 pb-3 last_borderdash activity_timeline_row">
                            <span className="activity_timeline_icon">
                                <FontAwesomeIcon icon={faClockRotateLeft} />
                            </span>
                            <div className="activity_timeline_body">
                                <h6>{event.title}</h6>
                                <small className='mb-0'>
                                    {event.description}
                                    {event.causer && <span className="activity_timeline_causer"> — by {event.causer}</span>}
                                </small>
                                {event.changes && event.changes.length > 0 && (
                                    <div className="activity_timeline_changes">
                                        <button type="button" onClick={() => toggleChanges(event.id)}>
                                            {event.changes.length} {event.changes.length === 1 ? 'field' : 'fields'} changed
                                            <FontAwesomeIcon icon={expandedId === event.id ? faChevronUp : faChevronDown} />
                                        </button>
                                        {expandedId === event.id && (
                                            <ul>
                                                {event.changes.map((change, index) => (
                                                    <li key={index}>
                                                        <span className="activity_timeline_field">{change.label}</span>
                                                        <span className="activity_timeline_old">{renderChangeValue(change.old)}</span>
                                                        <FontAwesomeIcon icon={faChevronRight} />
                                                        <span className="activity_timeline_new">{renderChangeValue(change.new)}</span>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                )}
                            </div>
                            <span className="activity_timeline_date">{event.date || "No Date & Time"}</span>
                        </Grid>
                    ))}
                    {paginatedata && paginatedata.last_page > 1 && (
                        <Grid size={{ xs: 12 }} container justifyContent="center" className="mt-4 pagination_btn">
                            <button className='arrowpaginate'
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}>
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                            <div className="pagination">
                                {Array.from({ length: paginatedata.last_page }, (_, i) => i + 1).map((page) => (
                                    <button
                                        key={page}
                                        onClick={() => handlePageChange(page)}
                                        className={currentPage === page ? 'active' : ''}
                                    >
                                        {page}
                                    </button>
                                ))}
                            </div>
                            <button className='arrowpaginate'
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === paginatedata.last_page}>
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </Grid>
                    )}
                </>) : (
                    <div className="w-100 d-flex justify-content-center mt-4">
                        <p>No data to display</p>
                    </div>
                )}
            </>}
        </Grid>
    )
}

export default ActivityTimeline
